import { DayPlan } from "../../types/DayPlan";
import DB_PATH from "../DB_PATH";
import firebase from "../firebase";

export default async ({ dayPlan }: { dayPlan: DayPlan }) => {
  try {

    console.log('DayPlan', dayPlan)
    const firestore = firebase.firestore();
    const collectionRef = firestore.collection(DB_PATH.PLAN_DAY);

    // Generate an ID if one was not provided (treat empty string as missing)
    const dayPlanRef = dayPlan.id ? collectionRef.doc(dayPlan.id) : collectionRef.doc();
    const dayPlanId = dayPlan.id || dayPlanRef.id;

    // Avoid saving steps inside the day plan document
    const { steps, ...dayPlanData } = dayPlan;

    await dayPlanRef.set({ ...dayPlanData, id: dayPlanId });
  } catch (error) {
    console.error("Error creating daily step:", error);
  }
};
